module.exports = __webpack_public_path__ + "static/media/wolffox2_preview.4aa702d7.jpg";